import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import * as actionsPicking from '../../../../actions/pickingAction';
import ListItemOrder from './ListItemOrder';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import { translate, showMessageToastCustom } from '../../../../utils/util';
import PickingService from '../../../../services/PickingService';
import ListPagination from '../../../../components/UI/ListPaginationUl';
import { ENUMS } from '../../../../utils/constants';
import { getUser } from '../../../../services/auth';

const PickingListOrder = (props) => {
    const [message, setMessage] = useState('');
    const [typeMessage, setTypeMessage] = useState('startOrder');
    const [order, setOrder] = useState({});
    const [eventRouteClick, setEventRouteClick] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [orders, setOrders] = useState({ items: [] });
    const [refreshed, setRefreshed] = useState(false);

    const refreshComponent = () => {
        setRefreshed(!refreshed);
    };

    useEffect(() => {
        document.addEventListener('expeditionRefreshListOrders', refreshComponent);

        return () => {
            document.removeEventListener('expeditionRefreshListOrders', refreshComponent);
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.data?.items?.length > 0) {
            if (props.data?.items?.length > 0 && currentPage === 0) {
                setOrders(props.data);
            } else {
                props.data.items = [...orders.items, ...props.data.items];
                setOrders(props.data);
            }
        } else if (currentPage === 0) {
            setOrders(props.data);
        }
        // eslint-disable-next-line
    }, [props.data]);

    useEffect(() => {
        props.getOrders(props.filter, {
            PageIndex: currentPage
        });
        // eslint-disable-next-line
    }, [currentPage]);

    const onSelectItemChange = (event, selectedItem) => {
        setEventRouteClick(event.currentTarget.pathname);
        event.preventDefault();

        if (selectedItem.status === ENUMS.eOrderStatus.Waiting.value) {
            const messageDefault = translate('expedition:picking.confirm-order-start');
            setMessage(messageDefault.replace('{orderCode}', selectedItem.orderCode).replace('{supplierName}', selectedItem.supplierName));
            setOrder(selectedItem);
            showMessageModal();
        } else if (selectedItem.status === ENUMS.eOrderStatus.InProgress.value) {
            props.setSelectedOrder(selectedItem);
            props.history.push({
                pathname: event.currentTarget.pathname
            });
        } else {
            // eslint-disable-next-line max-len
            showMessageToastCustom(translate('general:warning'), `O pedido está ${order.status === ENUMS.eOrderStatus.Canceled.value ? translate(`expedition:${ENUMS.eOrderStatus.Canceled.text}`) : translate(`expedition:${ENUMS.eOrderStatus.Finished.text}`)}`, 8000, 'mdi mdi-alert-circle-outline orange-text');
        }
    };

    const showMessageModal = () => {
        if (!navigator.onLine) {
            setMessage(translate('expedition:picking.select-order-offline'));
        }

        const modal = M.Modal.init(document.getElementById('confirmOrderStart'));
        modal.open();
    };

    const onConfirmModal = () => {
        if (typeMessage === 'startOrder') {
            if (order.status === ENUMS.eOrderStatus.Waiting.value || (order.status === ENUMS.eOrderStatus.InProgress.value && order.startedBy !== getUser().userName)) {
                props.startOrder(order.orderId, () => {
                    props.setSelectedOrder(order);
                    props.history.push({
                        pathname: eventRouteClick
                    });
                });
            }
        } else if (typeMessage === 'unblockOrder') {
            setTypeMessage('startOrder');

            props.unblockOrder(order.orderId, () => {
                props.getOrders(props.filter, {
                    PageSize: ENUMS.ePagination.PageSize.value,
                    PageIndex: currentPage
                });
                refreshComponent();
            });
        }
    };

    const onUnlonckOrder = (event, selectedItem) => {
        setTypeMessage('unblockOrder');
        setOrder(selectedItem);
        const messageDefault = 'Confirma o desbloqueio do pedido {orderCode} do fornecedor {supplierName}';
        setMessage(messageDefault.replace('{orderCode}', selectedItem.orderCode).replace('{supplierName}', selectedItem.supplierName));
        showMessageModal();
    };
    const onUserTransfer = (event, selectedItem) => {
        props.setSelectedOrder(selectedItem);
        props.history.push({
            pathname: `orders/${selectedItem.orderCode}/usertransfer`
        });
    };

    return orders.totalCount > 0
        ? (
            <div id="listOrders">
                <ListPagination
                    page={orders.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    data={
                        orders.items.map((item) => {
                            return (
                                <ListItemOrder
                                    key={`o-${item.orderId}-${item.status}`}
                                    route={`./order/${item.orderCode}/missions`}
                                    data={item}
                                    onSelectChange={(event) => onSelectItemChange(event, item)}
                                    onClickUnlonckOrder={onUnlonckOrder}
                                    onClickUserTransfer={onUserTransfer}
                                />
                            );
                        })
                    }
                />
                <ConfirmModal
                    id="confirmOrderStart"
                    data={{ title: translate('validations:attention'), message }}
                    onConfirm={onConfirmModal}
                    btnCancel={translate('general:cancel')}
                    btnConfirm={translate('general:confirm')}
                />
            </div>
        )
        : null;
};

const mapStateToProps = (state) => {
    return {
        filter: state.pickingReducer.filter,
        orders: state.pickingReducer.orders
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedOrder: (order) => {
            dispatch(actionsPicking.selectOrder(order));
        },
        getOrders: (filter, pagination) => {
            dispatch(PickingService.getOrders(filter, pagination));
        },
        startOrder: (orderId, callback) => {
            dispatch(PickingService.startOrder(orderId, callback));
        },
        unblockOrder: (orderId, callback) => {
            dispatch(PickingService.unblockOrder(orderId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingListOrder)));
